import { type PropsWithChildren, memo } from 'react';


import { plot } from './ChartGrid.sty.js';
import { useGridPlotSize } from './hooks/useGridPlotSize.js';
import { Grid } from '../../../../layouts/grid/Grid.js';

/**
 * @internal
 */
export const ChartGridPlot = memo(({ children }: PropsWithChildren) => {
  const { ref } = useGridPlotSize();

  return (
    <Grid<'div'> ref={ref} className={plot} gridItem gridArea="plot">
      {children}
    </Grid>
  );
});
